// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8183) return "static/chunks/8183.5894b18f09f1073f.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"369":"e668d733","1167":"eaa97a03","4323":"fcc6c0fc"}[chunkId] || chunkId) + "-" + {"32":"6bb98e31619dcfbd","369":"be1c72ac2d410bc7","1167":"44f611205fe42f2a","4323":"9e8aa264f447c49a"}[chunkId] + ".js";
};